import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Stack,
  Typography,
  Checkbox,
  FormHelperText,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@mui/material";
import "react-quill/dist/quill.snow.css";
import { useHistory } from "react-router-dom";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  Breadcrumb,
  ButtonComponent,
  AntSwitchComponent,
} from "../../component";
import FormInput from "../../component/common/outlined-input";
import {
  createPermission,
  showModules,
  updateSubadmin,
  viewSubadmin,
} from "../../store/actions";
import addEditPermissionValidation from "../../validation/role-permission";
import editPermissionValidation from "../../validation/edit-role-permission";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const Rolemanagement = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useHistory();
  const [error, setError] = useState({});
  const [permissions, setPermissions] = useState([]);
  const [checktick, setchecktick] = useState([]);
  const location = useLocation();
  const [permissionArray, setpermissionArray] = useState([]);
  const [visibility, setVisibility] = useState({
    password: false,
    confirmPwd: false,
  });
  const [formdata, setFormdata] = useState({
    userName: "",
    email: "",
    password: "",
    // status: 1,
    permissions: [],
  });

  const handleBack = () => {
    history.push("/role-management");
  };
  const handleCancel = () => {
    history.goBack();
  };

  

  useEffect(() => {
    if (params.id) {
      dispatch(
        viewSubadmin({
          form: { id: params.id },
          callback: (viewdata) => {
            
            setFormdata((prevState) => ({
              ...prevState,
              id: viewdata?._id,
              userName: viewdata?.userName,
              email: viewdata?.emailAddress,
              password: viewdata?.password,
              permissions: viewdata?.permissions?.map(permission => permission._id) || [],
            }));
          },
        })
      );
    }
  }, [params.id])

  const handleSubmit = (e) => {
    const { errors, isValid } =
      location?.state?.access === "Add"
        ? addEditPermissionValidation(formdata)
        : editPermissionValidation(formdata);
    if (isValid) {
      if (params.id !== "show") {
       
        
        const tempForm = {
          id: params?.id,
          userName: formdata?.userName,
          email: formdata?.email,
          password: formdata?.password,
          permissions: formdata?.permissions,
        };

        dispatch(
          updateSubadmin({
            form: tempForm,
            callback: (d) => {
              history.push("/role-management");
            },
          })
        );
      } else {
        console.log("2");
        const form = new FormData();
        form.append("name", formdata?.name || "");
        form.append("email", formdata?.email);

        e.preventDefault();

        const PermissionData = {
          userName: formdata?.userName,
          email: formdata?.email,
          password: formdata?.password,
          // status: formdata?.status,
          permissions: formdata?.permissions,
        };
        
        dispatch(
          createPermission({
            form: PermissionData,
            callback: (d) => {
              
              history.push("/role-management");
            },
          })
        );
      }
    } else {
      setError(errors);
    }
    // if (params.id) {

    // }

    // else {

    //   let tempForm;
    // if (formdata?.password) {
    //   tempForm = {
    //     id: params?.id,
    //     email: formdata?.email,
    //     mobile: formdata?.mobile,
    //     name: formdata?.name,
    //     permissions: JSON.stringify(formdata?.permissions),
    //   };
    // }

    // else {
    //   tempForm = {
    //     id: params?.id,
    //     email: formdata?.email,
    //     mobile: formdata?.mobile,
    //     name: formdata?.name,
    //     permissions: JSON.stringify(formdata?.permissions),
    //   };
    // }
    // dispatch(
    //   createPermission({
    //     form: tempForm,
    //     callback: (d) => {
    //       history.push("/role-management");
    //     },
    //   })
    // );
    // }
    // } else {
    //   setError(errors);
    // }
  };

  useEffect(() => {
    dispatch(
      showModules({
        callback: (showData) => {
          setpermissionArray(showData);
          const checkTick = showData.map((e) => ({ key: e._id }));
          setchecktick(checkTick);
          setPermissions(showData.permissions);
        },
      })
    );
  }, [dispatch]);

  const handleCheck = (event) => {
    const moduleId = event.target.value;
    const updatedPermissions = [...formdata.permissions];

    if (event.target.checked) {
      updatedPermissions.push(moduleId);
    } else {
      const index = updatedPermissions.indexOf(moduleId);
      if (index > -1) {
        updatedPermissions.splice(index, 1);
      }
    }

    setFormdata({ ...formdata, permissions: updatedPermissions });
  };

  const handleClickNewPassword = (name) =>
    setVisibility((prev) => ({ ...prev, [name]: !visibility[name] }));

  return (
    <Box sx={{ width: "100%" }} className={"mx-2"}>
      <Box className={"d-flex justify-content-between"}>
        <Box>
          <Typography variant="h5" className="poppins-font-family">
            Role Management
          </Typography>
          <Breadcrumb
            items={[
              { page: "Home", path: "/dashboard" },
              { page: "Role Management", path: "/role-management" },
            ]}
            active={{ page: location?.state?.access }}
          />
        </Box>

        <Box>
          <ButtonComponent
            variant="contained"
            buttonName="Back"
            className={`login-btn ms-1`}
            color={"error"}
            handleClick={handleBack}
          />
        </Box>
      </Box>

      <Box>
        <Grid item className={"card-background p-4"}>
          <Stack>
            <FormInput
              inputLabel={"userName"}
              placeholder={"Enter userName"}
              name={"userName"}
              value={formdata.userName}
              onChange={(e) =>
                setFormdata({ ...formdata, userName: e.target.value })
              }
              type="text"
              error={error.userName}
              helperText={error.userName}
              isRequired={true}
              disabled={location?.state?.access === "View"}
            />
          </Stack>
          <Stack>
            <FormInput
              inputLabel={"Email"}
              placeholder={"Enter email"}
              name={"email"}
              type="email"
              error={error.email}
              helperText={error.email}
              value={formdata.email}
              onChange={(e) =>
                setFormdata({ ...formdata, email: e.target.value })
              }
              isRequired={true}
              disabled={location?.state?.access === "View"}
            />
          </Stack>
          <Stack>
            <FormControl variant="standard" sx={{ margin: "5px 5px" }}>
              <Typography className="field-label">
                Password <span className="helper-text">*</span>
              </Typography>
              <OutlinedInput
                id="filled-adornment-password"
                className={`input-box`}
                type={visibility.password ? "text" : "password"}
                name={"password"}
                placeholder={"Enter password"}
                value={formdata?.password}
                error={error.password}
                onChange={(e) =>
                  setFormdata({ ...formdata, password: e.target.value })
                }
                disabled={location?.state?.access === "View"}
                sx={{ margin: "0px" }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => handleClickNewPassword("password")}
                      edge="end"
                    >
                      {!visibility.password ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
              <FormHelperText error className={`helper-text`}>
                {error.password}
              </FormHelperText>
            </FormControl>
          </Stack>
          {/* <Stack className="my-2">
            <Typography className="field-label ms-1">
              Status<span className="helper-text"> *</span>
            </Typography>
            <AntSwitchComponent
              checked={formdata.status}
              handleClick={(e) => setFormdata({ ...formdata, status: Number(e.target.checked) })}
              disabled={location?.state?.access === "View"}
            />
          </Stack> */}
        </Grid>
        <Grid item className={"card-background p-4"}>
          <Typography variant="h6" className="poppins-font-family">
            Permission
          </Typography>
          <table className="table">
            <thead>
              <tr>
                <th>Modules</th>
                <th className="text-center" style={{ fontSize: "14px" }}>
                  Permission
                </th>
              </tr>
            </thead>
            <tbody>
              {permissionArray?.map((admin_module, index) => (
                <tr data-index={index} key={admin_module._id}>
                  <td>{admin_module.name}</td>

                  <td style={{ textAlign: "center" }}>
                    <Checkbox
                      value={admin_module._id}
                      checked={formdata.permissions.includes(admin_module._id)}
                      className="text-center"
                      disabled={
                        window.location.search ||
                        location?.state?.access === "View"
                      }
                      onChange={handleCheck}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Grid>
        {location?.state?.access !== "View" && (
          <Grid item className="d-flex" ml={0.5} mt={2}>
            <ButtonComponent
              type="submit"
              variant="contained"
              buttonName={
                formdata.id && formdata.id !== "show" ? "Update" : "Submit"
              }
              className={`common-btn`}
              handleClick={handleSubmit}
            />
            <ButtonComponent
              variant="contained"
              buttonName="Cancel"
              handleClick={handleCancel}
              className={`danger-btn`}
              style={{ marginLeft: "10px" }}
            />
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default Rolemanagement;
